export const PILOT_MODULATORS_CARD_FRENCH_LOCALE = {
  title: "Modulateurs",
};
